import { graphql } from "@/api/graphql/types/gql.ts";

export const duplicateFormDataRuleGroupMutation = graphql(`
  mutation DuplicateFormDataRuleGroup($id: ID!) {
    MiddleMsDuplicateFormDataRuleGroup(request: { id: $id }) {
      id
    }
  }
`);
